import { customRef, watch, ref, Ref, reactive } from 'vue'
import { cloneDeep } from 'lodash'
import DeepProxy from 'proxy-deep'
import { isPojo } from '@prodcard/core'

function updateValue(key: string, value: unknown) {
  const oldState = window.history.state
  const newState = {
    ...oldState,
    [key]: cloneDeep(value),
  }

  window.history.replaceState(newState, '')
}

export function useWatcherSavedRef<T>(mainKey: string, defaultValue?: T): Ref<T> {
  const refValue = ref(window.history.state[mainKey] ?? defaultValue)

  watch(
    refValue,
    newVal => {
      updateValue(mainKey, newVal)
    },
    { deep: true },
  )
  return refValue
}

/**
 * @deprecated Better use useWatcherSavedRef
 */
export function useHistorySavedRef<T>(mainKey: string, defaultValue: T) {
  let currentValue = defaultValue

  return customRef((track, trigger) => {
    return {
      get() {
        track()
        const valueFromHistory = window.history.state[mainKey]
        const value = valueFromHistory ?? currentValue

        if (value && isPojo(value)) {
          return new DeepProxy(value, {
            get(target, key, receiver) {
              const val = Reflect.get(target, key, receiver)
              if (isPojo(val) || Array.isArray(val)) {
                return this.nest(val)
              } else {
                return val
              }
            },
            set(target, key, value) {
              target[key as string] = value
              trigger()
              updateValue(mainKey, this.rootTarget)
              return true
            },
          })
        }

        return value
      },
      set(newValue) {
        updateValue(mainKey, newValue)
        currentValue = newValue
        trigger()
      },
    }
  })
}
